import { format, isToday, isYesterday } from "date-fns";

const isDateObject = (date) => {
  return date instanceof Date;
};

const dateFormats = {
  simpleDate: "MMMM d, yyyy",
  simpleDateAbbreviated: "MMM d, yyyy",
  ordinalDateAbbreviated: "MMM do, yyyy",
  simpleDateTime: "MMMM d, yyyy h:mm a",
  simpleTime: "h:mm a",
};

export const formatDate = (type) => {
  if (!(type in dateFormats)) {
    throw Error(
      "An incorrect date type was supplied. It must be one of the following: simpleDate, simpleDateAbbreviated, simpleDateTime"
    );
  }
  return (date) => {
    return isDateObject(date) ? format(date, dateFormats[type]) : "";
  };
};

export const getDateLabel = (date) => {
  if (isToday(date)) return "Today";
  if (isYesterday(date)) return "Yesterday";

  return format(date, dateFormats.ordinalDateAbbreviated);
};

export default formatDate;
